import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'

import Arrow from '@/atoms/Arrow/Arrow'
import Breadcrumbs from '@/atoms/Breadcrumb'

import Default from '../Default'
import HelpNavigation from './HelpNavigation'
import css from './scss/Help.module.scss'
import { HelpProps } from './ts'

function Help({ children }: HelpProps) {
  const { t } = useTranslation('help')
  const [open, setOpen] = useState(false)

  return (
    <Default>
      <Breadcrumbs
        crumbs={[{ label: t('global:help_center') }]}
        className="mb-12"
      />
      <div className="box">
        <h3 className="pl-8 mb-8 text-2xl font-medium lg:hidden">
          {t('help_center')}
        </h3>
        <div className={css.wrapper}>
          <div
            className={clsx(css['wrapper-container'], 'transform', {
              '-translate-x-80 lg:translate-x-0': !open,
            })}
          >
            <aside
              className={clsx(css['wrapper-container--aside'], 'pt-16 lg:pt-0')}
            >
              <button
                onClick={() => setOpen(false)}
                className={clsx(css['wrapper-arrow'], 'right-0', {
                  'opacity-0 pointer-events-none': !open,
                })}
              >
                <span className="w-4 h-4 p-1">
                  <Arrow direction="left" variant="chevron" />
                </span>
                zamknij
              </button>
              <HelpNavigation />
            </aside>
            <section
              className={clsx(
                css['wrapper-container--section'],
                'pt-16 lg:pt-0'
              )}
            >
              <button
                onClick={() => setOpen(true)}
                className={clsx(css['wrapper-arrow'], 'left-0', {
                  'opacity-0 pointer-events-none': open,
                })}
              >
                nawigacja
                <span className="w-4 h-4 p-1">
                  <Arrow direction="right" variant="chevron" />
                </span>
              </button>
              <div>{children}</div>
            </section>
          </div>
        </div>
      </div>
    </Default>
  )
}

export default Help
